import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  pt: {
    translation: {
      common: {
        loading: 'Carregando...',
        success: 'Sucesso!',
        error: 'Erro ao processar.',
        submit: 'Enviar'
      },
      header: {
        modePersonnel: 'Pessoal',
        modeCorporate: 'Empresa',
        howItWorks: 'Como Funciona',
        services: 'Serviços',
        benefits: 'Vantagens',
        contact: 'Contacto',
        scheduleDemo: 'Agendar Demo',
        downloadApp: 'Descarregar App'
      },
      hero: {
        taglinePersonal: 'Mova-se por Luanda sem Stress',
        titlePersonal: 'Rápido. Seguro. Ao Preço Certo.',
        descPersonal: 'A forma mais eficiente de driblar o trânsito em Luanda. Motoqueiros qualificados à distância de um clique.',
        taglineCorporate: 'Solução Corporativa Oficial',
        titleCorporate: 'A Solução Definitiva de Mobilidade para a sua Empresa.',
        descCorporate: 'Reduza custos operacionais, centralize o controlo de frotas e garanta pontualidade total para a sua equipa com o SLA exclusivo MotoRush.',
        btnDownloadNow: 'Descarregar Agora',
        btnSpeakExpert: 'Falar com Especialista',
        btnWatchVideo: 'Ver Como Funciona'
      },
      socialProof: {
        companiesTitle: 'Empresas que Confiam na Nossa Frota',
        benefits: {
          coverage: 'Cobertura Total',
          security: 'Segurança Certificada',
          fast: 'Velocidade Real'
        }
      },
      sla: {
        title: 'SLA Corporativo de Elite',
        subtitle: 'Contrato de Nível de Serviço que blinda a operação logística da sua empresa em Luanda.',
        informalTitle: 'O Mercado Informal Comum',
        informalList: {
          pricing: 'Tarifa Dinâmica Abusiva: Preços flutuam de acordo com a chuva, trânsito ou hora do dia sem qualquer padrão.',
          security: 'Risco de Segurança: Condutores sem identificação, sem registo criminal verificado e motas sem manutenção.',
          billing: 'Facturação Individual: Colaboradores gastam dinheiro físico e exigem reembolsos manuais complexos no final do mês.',
          tracking: 'Sem Rastreamento: Impossível saber onde estão as encomendas ou onde os colaboradores estão localizados em caso de atraso.'
        },
        officialTitle: 'MotoRush Corporate SLA',
        officialList: {
          pricing: 'Preço Fixo Contratual: Tarifas corporativas estáveis e previsíveis, acordadas em contrato.',
          security: 'Condutores Certificados: Motoqueiros profissionais uniformizados, verificados criminalmente e sob constante avaliação.',
          billing: 'Factura Única Mensal: ERP integrado que consolida todas as viagens da empresa numa única factura pós-paga corporativa.',
          tracking: 'Telemetria de Frota: Painel de gestão corporativo com localização GPS em tempo real e relatórios de rotas.'
        },
        pillars: {
          pricingTitle: 'Preço Fixo S/ Surpresas',
          pricingDesc: 'Tabela de preços fixa sem tarifa dinâmica. Pague o mesmo faça sol ou chuva, garantindo controlo total do seu orçamento.',
          billingTitle: 'Facturação Mensal Pós-Paga',
          billingDesc: 'Centralize todos os custos. A sua empresa faz as viagens durante o mês e recebe uma factura detalhada electrónica pós-paga com 30 dias para pagamento.',
          securityTitle: 'Segurança & Telemetria',
          securityDesc: 'Localização em tempo real das suas entregas e equipas. Motoqueiros treinados com colete reflector, dois capacetes e seguro contra acidentes.'
        }
      },
      b2bForm: {
        tagline: 'Escala Corporativa',
        title: 'Pronto para Revolucionar a Logística da sua Empresa?',
        subtitle: 'Preencha os dados abaixo. O nosso Account Manager entrará em contacto em menos de 2 horas úteis para desenhar o plano ideal.',
        form: {
          managerLabel: 'Nome do Gestor/Responsável *',
          emailLabel: 'Email Corporativo *',
          phoneLabel: 'Telefone / WhatsApp *',
          companyLabel: 'Nome da Empresa (Razão Social) *',
          nifLabel: 'NIF da Empresa *',
          employeesLabel: 'Quantos Colaboradores utilizarão o serviço?',
          employeesPlaceholder: 'Seleccione uma estimativa',
          submitBtn: 'Solicitar Proposta e Demo',
          sending: 'A Enviar Solicitação...'
        }
      },
      footer: {
        about: 'Conectando Angola através de transporte rápido, seguro e sustentável. O futuro da mobilidade urbana em Luanda.',
        quickLinks: 'Links Rápidos',
        services: {
          title: 'Serviços',
          passenger: 'Transporte de Passageiros',
          delivery: 'Entrega de Encomendas',
          scheduled: 'Corridas Agendadas',
          loyalty: 'Programa de Fidelidade'
        },
        contact: 'Contacto',
        appDownload: 'Descarregue a App',
        madeIn: 'Feito com ❤️ em Angola',
        rights: 'Todos os direitos reservados.',
        legal: {
          privacy: 'Política de Privacidade',
          terms: 'Termos de Uso',
          cookies: 'Cookies',
          help: 'Ajuda'
        }
      },
      aboutUs: {
        title: 'Quem Somos',
        hero1: 'Em Luanda, quem chega primeiro fecha o negócio. Nós existimos para garantir que esse alguém seja você.',
        hero2: 'A Motorush é a plataforma digital de Mobilidade e Logística Corporativa que resolve uma dor real: milhões de kwanzas parados à espera de documentos, assinaturas ou encomendas. Cada hora de espera é um contrato adiado e uma oportunidade que muda de mãos.',
        hero3: 'Por isso construímos um modelo diferente:',
        model1Title: 'Frota própria:',
        model1Text: 'Sem intermediários nem subcontratações de última hora.',
        model2Title: 'Equipa qualificada:',
        model2Text: 'Motoqueiros rigorosamente formados e identificados.',
        model3Title: 'Controlo absoluto:',
        model3Text: 'Tecnologia de rastreio em tempo real do início ao fim.',
        hero4: 'Trabalhamos com empresas de todas as dimensões e sectores, porque a urgência não escolhe área de actuação. Com a Motorush, deixa de perguntar "já entregaram?" e passa a ter o controlo total no seu ecrã.',
        routePoint1: 'Recolha',
        routePoint2: 'Em trânsito',
        routePoint3: 'Entregue',
        mission: 'Missão',
        missionSubtitle: 'Transformar cada viagem e entrega numa promessa cumprida.',
        missionText: 'Garantimos eficiência, rapidez e segurança na distribuição de documentos e mercadorias corporativas. Assumimos o peso da rua para que a sua equipa se dedique ao que realmente importa: fazer o negócio crescer.',
        vision: 'Visão',
        visionSubtitle: 'Ser o nome que qualquer empresa angolana pronuncia quando a entrega não pode falhar.',
        visionText: 'Liderar a Mobilidade e logística B2B em Angola pela robustez operacional e pelo rigor inegociável nos prazos. Mais do que ser os maiores, queremos ser a escolha de confiança de olhos fechados.',
        valuesTitle: 'Os Nossos Valores',
        valuesSubtitle: 'Os pilares que sustentam a nossa excelência operacional e o compromisso com os parceiros.',
        val1Title: 'Versatilidade e Disponibilidade',
        val1Text: 'Adaptamos a nossa operação às necessidades específicas de qualquer sector empresarial, do comércio aos serviços.',
        val2Title: 'Compromisso com o Cliente',
        val2Text: 'O cumprimento estrito dos prazos de entrega é a nossa prioridade absoluta; o sucesso do parceiro é o nosso sucesso.',
        val3Title: 'Inovação Prática',
        val3Text: 'Utilizamos tecnologia desenvolvida à medida para trazer transparência e controlo total em cada etapa do percurso.',
        val4Title: 'Profissionalismo e Disciplina',
        val4Text: 'Valorizamos a nossa equipa de estafetas e gestores, mantendo elevados padrões de apresentação, ética e responsabilidade no asfalto.',
        partnersTitle: 'Quem Confia em Nós',
        partnersSubtitle: 'Empresas em Luanda que contam diariamente com a pontualidade, rigor e segurança da nossa frota.'
      }
    }
  },
  en: {
    translation: {
      common: {
        loading: 'Loading...',
        success: 'Success!',
        error: 'Error processing request.',
        submit: 'Submit'
      },
      header: {
        modePersonnel: 'Personal',
        modeCorporate: 'Corporate',
        howItWorks: 'How it Works',
        services: 'Services',
        benefits: 'Benefits',
        contact: 'Contact',
        scheduleDemo: 'Book a Demo',
        downloadApp: 'Download App'
      },
      hero: {
        taglinePersonal: 'Move through Luanda stress-free',
        titlePersonal: 'Fast. Safe. Fairly Priced.',
        descPersonal: 'The most efficient way to beat traffic in Luanda. Qualified riders at the push of a button.',
        taglineCorporate: 'Official Corporate Solution',
        titleCorporate: 'The Ultimate Mobility Solution for your Business.',
        descCorporate: 'Reduce operational costs, centralize fleet control, and guarantee absolute punctuality for your team with MotoRush exclusive SLA.',
        btnDownloadNow: 'Download Now',
        btnSpeakExpert: 'Talk to an Expert',
        btnWatchVideo: 'See How it Works'
      },
      socialProof: {
        companiesTitle: 'Companies That Trust Our Fleet',
        benefits: {
          coverage: 'Total Coverage',
          security: 'Certified Security',
          fast: 'Real Speed'
        }
      },
      sla: {
        title: 'Elite Corporate SLA',
        subtitle: 'Service Level Agreement shielding your company\'s logistics operations in Luanda.',
        informalTitle: 'The Common Informal Market',
        informalList: {
          pricing: 'Abusive Dynamic Pricing: Prices fluctuate based on rain, traffic, or time of day without any logic.',
          security: 'Security Risk: Unidentified riders, no background checks, and non-maintained motorcycles.',
          billing: 'Individual Billing: Employees spend cash and demand complex manual refunds at the end of the month.',
          tracking: 'No Tracking: Impossible to know where packages or employees are located during delays.'
        },
        officialTitle: 'MotoRush Corporate SLA',
        officialList: {
          pricing: 'Contractual Fixed Pricing: Stable and predictable corporate rates, agreed upon by contract.',
          security: 'Certified Riders: Uniformed professional riders, background checked, and constantly evaluated.',
          billing: 'Single Monthly Invoice: Integrated ERP consolidating all company rides into a single post-paid corporate invoice.',
          tracking: 'Fleet Telemetry: Corporate management dashboard with real-time GPS location and route reports.'
        },
        pillars: {
          pricingTitle: 'Fixed Price No Surprises',
          pricingDesc: 'Fixed price table without surge pricing. Pay the same come rain or shine, guaranteeing full budget control.',
          billingTitle: 'Monthly Post-paid Billing',
          billingDesc: 'Centralize all costs. Your company takes rides during the month and receives a detailed electronic post-paid invoice with a 30-day term.',
          securityTitle: 'Security & Telemetry',
          securityDesc: 'Real-time location of your deliveries and teams. Trained riders with reflective vest, two helmets, and accident insurance.'
        }
      },
      b2bForm: {
        tagline: 'Corporate Scale',
        title: 'Ready to Revolutionize Your Company\'s Logistics?',
        subtitle: 'Fill out the details below. Our Account Manager will reach out in less than 2 business hours to design the ideal plan.',
        form: {
          managerLabel: 'Manager Name *',
          emailLabel: 'Corporate Email *',
          phoneLabel: 'Phone / WhatsApp *',
          companyLabel: 'Company Name *',
          nifLabel: 'Company Tax ID (NIF) *',
          employeesLabel: 'How many employees will use the service?',
          employeesPlaceholder: 'Select an estimate',
          submitBtn: 'Request Quote & Demo',
          sending: 'Sending Request...'
        }
      },
      footer: {
        about: 'Connecting Angola through fast, safe, and sustainable transport. The future of urban mobility in Luanda.',
        quickLinks: 'Quick Links',
        services: {
          title: 'Services',
          passenger: 'Passenger Transport',
          delivery: 'Parcel Delivery',
          scheduled: 'Scheduled Rides',
          loyalty: 'Loyalty Program'
        },
        contact: 'Contact',
        appDownload: 'Get the App',
        madeIn: 'Made with ❤️ in Angola',
        rights: 'All rights reserved.',
        legal: {
          privacy: 'Privacy Policy',
          terms: 'Terms of Use',
          cookies: 'Cookies',
          help: 'Help'
        }
      },
      aboutUs: {
        title: 'About Us',
        hero1: 'In Luanda, whoever arrives first closes the deal. We exist to ensure that someone is you.',
        hero2: 'Motorush is the digital Corporate Mobility and Logistics platform that solves a real pain: millions of kwanzas stalled waiting for documents, signatures, or parcels. Every hour of waiting is a postponed contract and an opportunity changing hands.',
        hero3: 'That is why we built a different model:',
        model1Title: 'In-house fleet:',
        model1Text: 'No middlemen or last-minute subcontracting.',
        model2Title: 'Qualified team:',
        model2Text: 'Riders strictly trained and identified.',
        model3Title: 'Absolute control:',
        model3Text: 'Real-time tracking technology from start to finish.',
        hero4: 'We work with companies of all sizes and sectors, because urgency does not choose an industry. With Motorush, you stop asking "have they delivered?" and gain full control on your screen.',
        routePoint1: 'Pickup',
        routePoint2: 'In transit',
        routePoint3: 'Delivered',
        mission: 'Mission',
        missionSubtitle: 'Transforming every trip and delivery into a fulfilled promise.',
        missionText: 'We guarantee efficiency, speed, and security in the distribution of corporate documents and goods. We take on the burden of the streets so your team can focus on what really matters: growing the business.',
        vision: 'Vision',
        visionSubtitle: 'To be the name any Angolan company pronounces when a delivery cannot fail.',
        visionText: 'Leading B2B Mobility and logistics in Angola through operational robustness and non-negotiable strictness on deadlines. More than being the largest, we want to be the trusted choice with eyes closed.',
        valuesTitle: 'Our Values',
        valuesSubtitle: 'The pillars that sustain our operational excellence and commitment to our partners.',
        val1Title: 'Versatility and Availability',
        val1Text: 'We adapt our operations to the specific needs of any business sector, from retail to services.',
        val2Title: 'Commitment to the Client',
        val2Text: 'Strict compliance with delivery deadlines is our absolute priority; our partner\'s success is our success.',
        val3Title: 'Practical Innovation',
        val3Text: 'We use custom-developed technology to bring total transparency and tracking to every stage of the journey.',
        val4Title: 'Professionalism and Discipline',
        val4Text: 'We value our team of riders and managers, maintaining high standards of presentation, ethics, and responsibility on the road.',
        partnersTitle: 'Who Trusts Us',
        partnersSubtitle: 'Companies across Luanda that rely daily on our fleet\'s punctuality, rigor, and security.'
      }
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'pt',
    interpolation: {
      escapeValue: false // react already safes from xss
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage']
    }
  });

export default i18n;
